export default __webpack_public_path__ + "static/media/logo.468156ed.png";